import { AxiosError, isAxiosError } from "axios";
import toast from "react-hot-toast";

export class AtiraToast {
  static autoClose = 5;
  static style: React.CSSProperties = {};
  static theme = "colored";
  private static toastMap: Map<string, number> = new Map();

  static success(message: string) {
    toast(message || "Operation successful", {
      duration: AtiraToast.autoClose * 1000,
      style: {
        border: "1px solid #0f0",
        padding: "16px",
        color: "#0f0",
        backgroundColor: "#fff",
        fontSize: "16px",
      },
    });
  }

  static error(message: string) {
    toast(message || "Something went wrong", {
      duration: AtiraToast.autoClose * 1000,
      style: {
        border: "1px solid #f00",
        padding: "16px",
        color: "#f00",
        backgroundColor: "#fff",
        fontSize: "16px",
      },
    });
  }

  static apiError(e: any, config: any = {}) {
    console.log(e);
    let message = "";
    if (isAxiosError(e)) {
      if (typeof (e as AxiosError).response?.data === "string") {
        message = (e as AxiosError).response?.data as string;
      } else {
        message = (e as AxiosError).message;
      }
    } else if (typeof e.message === "string") {
      message = e.message;
    }

    toast(message || "Something went wrong", {
      duration: AtiraToast.autoClose * 1000,
      style: {
        border: "1px solid #f00",
        padding: "16px",
        color: "#f00",
        backgroundColor: "#fff",
        fontSize: "16px",
      },
    });
  }
}
